import { FC, useCallback, useMemo } from 'react';
import { Application, reassignAppStates } from '../../../core/applications';

import { findIndex, remove, sortBy } from 'lodash';

import { 
    AdminReassignForm,    
} from './forms'
import { isPopulatedArray } from '../../../../components/helpers';
import { useUserLoader } from '../../../core/users';


type Props = {
    appData: Application    
    reviewId?: number
    doClose: Function
}

const SubmitReassignForm: FC<Props> = ({appData, reviewId, doClose}) => {
        
    const { appid, assignedId, productTypeId, role }= useMemo(() => {
        if (! (appData)) {
            return { appid: 0, reviews: [], assignedId : 0, productTypeId: 0, role: ''};
        }
        
        let assignedId = appData.assignedTo && appData.assignedTo.id ? appData.assignedTo.id : 0;    
        let productTypeId = appData.productType && appData.productType.id ? appData.productType.id  : 0;                
        let appid = appData?.id ? appData.id : 0;
        let state = appData.state;
        
        const role_idx = findIndex(reassignAppStates, { state });
        let role = role_idx > -1 ? reassignAppStates[role_idx].role : '';
        
        return { appid, assignedId, productTypeId, role};

    }, [appData]);

    
    const select = useCallback((data: any) => { 
        if (! isPopulatedArray(data)) return [];
    
        // Remove current assignee when role is not CAMS Inspector
        if (role !== 'CAMS Inspector') {
            remove(data, (o: any) => (o.id && o.id > 0 && o.id === assignedId));
        }
        
        return sortBy( 
          data.map((o: any) => ({ value: o.id, text: o.name})), 
            [(o:any) => { return `${o.text}`.toLowerCase();}]
        );
    }, [role, assignedId]);
    
    const { data: assignees } = useUserLoader({userType: role, productTypeId, select });
      
    
    if (! (appData && appData.id && role)) {
        return <div className="fs-7 text-muted">Reassignment not possible at this time.</div>;
    }

    return(
    <div id='kt_submit_reassign_form' className='form'>
        <div
            className='d-flex flex-column scroll-y me-n7 pe-7'
            id='kt_submit_reassign_scroll'
            data-kt-scroll='true'
            data-kt-scroll-activate='{default: false, lg: true}'
            data-kt-scroll-max-height='auto'
            data-kt-scroll-dependencies='#kt_submit_reassign_header'
            data-kt-scroll-wrappers='#kt_submit_reassign_scroll'
            data-kt-scroll-offset='300px'
        >                        
			<AdminReassignForm appID={appid} reviewId={reviewId} role={role} assignees={assignees} doClose={doClose} assignedId={assignedId} />                        
        </div>
    </div>    
    )      
}

export {SubmitReassignForm}
